<template>
  <!-- фон тёмный всегда: весь текст футера белый, и на светлой странице
       (главная с прозрачной шапкой) контакты, меню и соцсети пропадали -->
  <div
    class="w-full flex justify-center pt-36 relative xl:px-12 2xl:px-24 px-4 relative bg-navy"
  >
    <footer-head v-if="callToAction" @buttonClick="$router.push(callToAction.route)">
      <template #title>
        {{ callToAction.title }}
      </template>

      <template #button-label>
        {{ callToAction.button }}
      </template>
    </footer-head>

    <div class="w-full flex justify-start 2xl:gap-16 gap-4 lg:flex-row flex-col-reverse">
      <div class="lg:w-1/4 w-full flex flex-col sm:items-center lg:items-start lg:pt-24 pt-10">
        <div class="flex flex-col sm:flex-row lg:flex-col justify-center sm:justify-between lg:justify-start gap-4 lg:gap-7">

          <div class="w-full flex justify-center sm:justify-start items-center lg:gap-2 gap-2 text-14 text-white">
            <div class="w-5 h-5 bg-email bg-no-repeat"/>
            <div>hr@dthreads.am</div>
          </div>

          <div class="w-full flex justify-center sm:justify-start items-center gap-2 text-14 text-white">
            <div class="w-5 h-5 bg-location bg-no-repeat"/>
            <div>Abelyan Street, 6/4, Yerevan, Armenia</div>
          </div>

          <div class="w-full flex justify-center sm:justify-start items-center gap-2 text-14 text-white">
            <div class="w-5 h-5 bg-phone bg-no-repeat"></div>
            <div>{{ sitePhoneNumber }}</div>
          </div>

        </div>

        <div class="flex justify-center items-center sm:justify-start gap-5 lg:mt-10 mt-6">
          <a href="https://www.facebook.com/digit.threads" target="_blank" class="block social-link p-3 -m-3">
            <span class="block w-6 h-6 bg-facebook bg-no-repeat cursor-pointer"/>
          </a>

          <a href="https://www.linkedin.com/company/digit-threads/?viewAsMember=true" target="_blank" class="block social-link p-3 -m-3">
            <span class="block w-6 h-6 bg-linkedin bg-no-repeat cursor-pointer"/>
          </a>

<!--          <a href="#" target="_blank" class="block social-link p-3 -m-3">-->
<!--            <div class="w-6 h-6 bg-instagram bg-no-repeat cursor-pointer"/>-->
<!--          </a>-->
        </div>
      </div>

      <div class="lg:w-2/4 w-full flex flex-col items-center gap-8">
        <div class="w-full flex justify-center">
          <router-link to="/" class="brand block py-1">
            <div class="w-28 h-10 bg-logo bg-no-repeat bg-cover"></div>
          </router-link>
        </div>
        <div class="w-full flex justify-center items-center sm:items-start lg:gap-8 gap-4 sm:flex-row flex-col" id="nav">
          <router-link class="text-white text-18 whitespace-nowrap relative py-3 px-2 flex items-center justify-center" to="/">Home</router-link>
          <router-link class="text-white text-18 whitespace-nowrap relative py-3 px-2 flex items-center justify-center" to="/about">About us</router-link>
          <router-link class="text-white text-18 whitespace-nowrap relative py-3 px-2 flex items-center justify-center" to="/services">Services</router-link>
          <router-link class="text-white text-18 whitespace-nowrap relative py-3 px-2 flex items-center justify-center" to="/projects">Projects</router-link>
          <router-link class="text-white text-18 whitespace-nowrap relative py-3 px-2 flex items-center justify-center" to="/careers">Careers</router-link>
          <router-link class="text-white text-18 whitespace-nowrap relative py-3 px-2 flex items-center justify-center" to="/contact-us">Contact us</router-link>
        </div>
      </div>
    </div>
  </div>

  <div
    class="
      px-4
      text-white
      flex
      flex-col sm:flex-row
      flex-wrap
      gap-2 sm:gap-6
      py-4
      bg-navy
      justify-center
    "
  >
    <router-link v-for="link in underLinks" :key="link.id" :to="link.link" class="legal-link underline opacity-70 text-12 sm:text-16 text-center py-3 px-2">
      {{ link.label }}
    </router-link>
    <p class="opacity-70 text-12 sm:text-16 text-center">
      © {{ currentYear }} Digital Threads. All rights reserved.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<script setup>
import { computed, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import FooterHead from '@/components/Footer/FooterHead'
import { useContent } from '@/composables/useContent'

const underLinks = reactive([
  {
    id: 1,
    label: 'Terms & Conditions',
    link: '/terms_and_conditions'
  },
  {
    id: 2,
    label: 'Privacy Policy',
    link: '/privacy_policy'
  }
])

const sitePhoneNumber = ref(process.env.VUE_APP_SITE_CONTACT_US_PHONE_NUMBER)

const route = useRoute()

// Текст блока и подпись кнопки берутся из настроек страницы в админке.
// Запасные значения нужны, пока данных нет или API недоступен.
const BLOCKS = {
  '/': { entity: 'homePage', route: 'careers', title: 'Wanna grow with our team?', button: 'Join us' },
  '/services': { entity: 'servicesPage', route: '/contact-us', title: 'Let’s talk about your project', button: 'Contact us' },
  '/about': { entity: 'aboutPage', route: '/contact-us', title: 'Let’s discuss your business needs', button: "Let's talk" },
  '/contact-us': { entity: 'contactPage', route: 'careers', title: 'Interested in job opportunities?', button: 'See Vacancies' },
  '/projects': { entity: 'projectsPage', route: 'contact-us', title: 'Let’s talk about your project', button: 'Contact Us' },
  '/careers': { entity: 'careersPage', route: 'contact-us', title: 'Have something else in mind?', button: 'Let’s Talk' },
}

const current = computed(() => {
  // адреса части страниц записаны с заглавной буквы (/About, /Careers),
  // поэтому сравниваем в нижнем регистре — иначе блок просто не покажется
  const path = route.path.toLowerCase().replace(/\/$/, '') || '/'

  if (path.includes('/project-info')) return BLOCKS['/services']

  return BLOCKS[path] ?? null
})

// на главной верхний блок и футер настраиваются отдельно, поэтому
// текст футера главной остаётся значением по умолчанию
const { items: pages } = useContent('servicesPage', [])
const { items: aboutPage } = useContent('aboutPage', [])
const { items: careersPage } = useContent('careersPage', [])
const { items: contactPage } = useContent('contactPage', [])
const { items: projectsPage } = useContent('projectsPage', [])

const BY_ENTITY = computed(() => ({
  servicesPage: pages.value[0],
  aboutPage: aboutPage.value[0],
  careersPage: careersPage.value[0],
  contactPage: contactPage.value[0],
  projectsPage: projectsPage.value[0],
}))

const callToAction = computed(() => {
  const block = current.value
  if (!block) return null

  const data = BY_ENTITY.value[block.entity]

  return {
    route: block.route,
    title: data?.c_sec_text || block.title,
    button: data?.c_sec_button || block.button,
  }
})
</script>

<style scoped>
/* то же, что в шапке: жирный на ховере расширяет буквы и двигает соседние ссылки */
#nav a::before {
  content: '';
  position: absolute;
  left: 50%;
  right: 50%;
  bottom: -6px;
  height: 2px;
  background-color: #FFCE1F;
  transition: left .25s ease, right .25s ease;
}

#nav a:hover::before {
  left: 0;
  right: 0;
}

@media (prefers-reduced-motion: reduce) {
  #nav a::before {
    transition: none;
  }
}

/* логотип и нижние ссылки тоже никак не реагировали на курсор */
.brand {
  transition: opacity .2s ease, transform .2s ease;
}

.brand:hover {
  opacity: .8;
  transform: translateY(-1px);
}

.legal-link {
  transition: opacity .2s ease;
}

.legal-link:hover {
  opacity: 1;
}

.legal-link:focus-visible,
.brand:focus-visible {
  outline: 2px solid #E8B300;
  outline-offset: 3px;
}

/* иконки соцсетей никак не реагировали на курсор */
.social-link {
  transition: transform .2s ease, opacity .2s ease;
  opacity: .85;
}

.social-link:hover {
  transform: translateY(-3px);
  opacity: 1;
}

.social-link:focus-visible {
  outline: 2px solid #E8B300;
  outline-offset: 4px;
}

@media (prefers-reduced-motion: reduce) {
  .social-link {
    transition: none;
  }

  .social-link:hover,
  .brand:hover {
    transform: none;
  }

  .brand,
  .legal-link {
    transition: none;
  }
}

#nav a.router-link-exact-active::before {
  display: none;
}

#nav a.router-link-exact-active {
  font-weight: bold;
}
</style>
